var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4143 7.32885L18.1716 3.08621L3.12157 18.1363L7.36421 22.3789L22.4143 7.32885Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.121 18.136L1 24.5L7.364 22.379L3.121 18.136Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 7.328L18.1721 3.086L18.8791 2.379C19.4449 1.83253 20.2027 1.53014 20.9893 1.53698C21.7759 1.54381 22.5283 1.85932 23.0846 2.41555C23.6408 2.97177 23.9563 3.72421 23.9631 4.5108C23.97 5.29739 23.6676 6.05519 23.1211 6.621L22.4141 7.328Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPencil;